export default __webpack_public_path__ + "static/media/winner_5.1f717331.jpg";